"use strict";
function pagination(){
    document.querySelectorAll(".load-more").forEach((btn) => {
      btn.classList.remove('loading');
      var url = btn.getAttribute('href');
      if (btn.classList.contains("infinite")){
        var observer = new IntersectionObserver(
          function(entries){
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1){
                loadMoreproducts(url);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(btn);
      } else {
        btn.addEventListener("click",(e) => {
            e.preventDefault();
            btn.classList.add('loading');
            loadMoreproducts(url);
          },
          false
        );
      }
    });
}
pagination();
function loadMoreproducts(url){
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'),
        products = document.getElementById('collection-products'),
        productsSource = html.querySelector('#collection-products').innerHTML,
        pagination = document.getElementById('pagination'),
        paginationSource = html.querySelector('#pagination');

      if(products) products.insertAdjacentHTML('beforeend', productsSource);
      if(pagination && paginationSource) {
        pagination.innerHTML = paginationSource.innerHTML;
      } else {
        pagination.innerHTML = '';
      }
    })
    .finally(() => {
      pagination();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
      initializeVideos();initBgimages();
      initializeScrollAnimationTrigger();
    })
    .catch((e) => {
      console.error(e);
    });
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var _this = this,
        fbtns = document.querySelectorAll(".btn-filter"),
        topFilters = document.querySelector(".filter-horizontal");

      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 767px)');
      this.drawerMql = window.matchMedia('(max-width: 1024px)');
      this.fbtns = fbtns;
      this.drawerOpen = false;
      this.closeBtn = this.querySelector('.closeFilter');

      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if(this.closeBtn) this.closeBtn.addEventListener('click', this.closeMobileFilters.bind(this));
      document.querySelectorAll('.modal-overly').forEach((ovr) =>
        ovr.addEventListener('click', () => { if(this.drawerOpen) this.closeMobileFilters(); })
      );
      this.addEventListener('keydown', this.drawerKeys.bind(this));
      document.addEventListener('focusin', (e) => {
        if(this.drawerOpen && this.isDrawer() && !this.contains(e.target) && this.closeBtn) this.closeBtn.focus({ preventScroll:true });
      });
      this.drawerMql.addEventListener('change', () => this.setDrawerState());
      this.setDrawerState();
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      this.selectSort();

      document.addEventListener('change', function(e){
        if (!e.target.classList.contains('optTag')) return;

        var URL = _this.dataset.url,
            paramString = new URLSearchParams(window.location.search),
            productFilters = document.querySelectorAll('input.optTag'),
            newTags = [],
            bytags = true;

        productFilters.forEach(function(el){
            if(el.value && el.checked){
                newTags.push(el.value);
            }
        });

        if (newTags.length) {
            var tags = newTags.join('+');
            _this.renderSectionFromFetch(URL + '/' + tags + '?' + paramString, bytags);
        } else {
            _this.renderSectionFromFetch(URL + '?' + paramString, bytags);
        }
      });

  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    shortby.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input.dyfl, .price-range');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  priceRangeSlider(){
    const isPriceRange = document.getElementById('priceSlider');
    if(!isPriceRange) return;
    const priceSlider = document.getElementById('priceSlider'),
      min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE');

    customElements.whenDefined('tc-range-slider').then(() => {
      const root = priceSlider.shadowRoot;
      if(!root) return;
      const pointers = root.querySelectorAll('.pointer');
      if(pointers[0] && min) pointers[0].setAttribute('aria-label', min.getAttribute('aria-label'));
      if(pointers[1] && max) pointers[1].setAttribute('aria-label', max.getAttribute('aria-label'));
      if(root.querySelector('style[data-focus]')) return;
      const focusStyle = document.createElement('style');
      focusStyle.dataset.focus = '';
      focusStyle.textContent = '.pointer:focus-visible .pointer-shape{outline:2px solid #4A90E2;outline-offset:2px}';
      root.appendChild(focusStyle);
    });
    priceSlider.addEventListener('change', (evt) => {
        min.value = evt.detail.value1.toString();
        max.value = evt.detail.value2.toString();
    });
    priceSlider.addEventListener('onMouseUp', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
    priceSlider.addEventListener('touchend', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
  }
  onFormSubmit(e){
    const flForm = this.querySelector('form'),
      formData = new FormData(flForm),
      params = new URLSearchParams(formData);
      this.renderSectionFromFetch(params);
  }
  renderSectionFromFetch(params,tags){
    var url = `${window.location.pathname}?section_id=${this.secId}&${params.toString()}`
    if(tags){
        var url = `${params}&section_id=${this.secId}`
    }

    const focusedId = this.contains(document.activeElement) ? document.activeElement.id : '';
    document.body.classList.add('load-filters');
    fetch(url).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html'),
          products = document.getElementById('collection-products'),
          filters = this.querySelector('.filters-item__wrapper'),
          counts = document.getElementById('itemsCount'),
          pagination = document.getElementById('pagination'),
          paginationSource =  html.querySelector('#pagination'),
          activeFilters =  document.getElementById('active-filters');

        if(counts) counts.innerHTML = html.querySelector('#itemsCount').innerHTML;
        if(activeFilters) activeFilters.innerHTML = html.querySelector('#active-filters').innerHTML;
        if(products) products.innerHTML = html.querySelector('#collection-products').innerHTML;
        const productsSource = html.querySelector('#collection-products');
        if(productsSource && productsSource.dataset.count) document.dispatchEvent(new CustomEvent('collection:count', { detail: { count: Number(productsSource.dataset.count) } }));
        if(filters) filters.innerHTML = html.querySelector('.filters-item__wrapper').innerHTML;
        if(focusedId && document.getElementById(focusedId)) document.getElementById(focusedId).focus({ preventScroll:true });
        if(pagination && paginationSource) {
          pagination.innerHTML = paginationSource.innerHTML;
        } else if(pagination) {
          pagination.innerHTML = ' ';
        }
      })
      .finally(() => {
        if(tags){
            var url = `${params.toString()}`
        } else {
            var url = `${window.location.pathname}?${params.toString()}`
        }
        history.pushState({ page: url }, url, url);
        document.body.classList.remove('load-filters');
        this.selectFilters();this.priceRangeSlider();this.removeFilters();pagination();
        if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
        initializeVideos();initBgimages();
        initializeScrollAnimationTrigger();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  removeFilters(){
    var _this = this,
        activeFl = document.querySelectorAll(".active-fl");
    activeFl.forEach((btn) => {
        btn.addEventListener("click",(e) => {
          e.preventDefault();
          var params = btn.getAttribute('href').split('?')[1];
          _this.renderSectionFromFetch(params);
        })
      });
  }
  mobileFilters(e){
    var html = document.documentElement;
    this.filterTrigger = e ? e.currentTarget : null;
    html.classList.add('activ-filter','show-overly');
    const blocks = this.querySelectorAll('.filters-item');
    blocks.forEach((blk) => {
      blk.open = true;
    });
    this.drawerOpen = true;
    this.setDrawerState();
    if(this.closeBtn) this.closeBtn.focus({ preventScroll:true });
  }
  closeMobileFilters(){
    document.documentElement.classList.remove('activ-filter','show-overly');
    this.drawerOpen = false;
    this.setDrawerState();
    if(this.filterTrigger) this.filterTrigger.focus({ preventScroll:true });
  }
  isDrawer(){
    return this.classList.contains('sidebar-popup') || this.drawerMql.matches;
  }
  setDrawerState(){
    const isDialog = this.isDrawer() && this.drawerOpen;
    if(isDialog){
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      this.setAttribute('aria-label', this.fbtns.length ? this.fbtns[0].getAttribute('aria-label') : 'Filter');
    } else {
      this.removeAttribute('role');
      this.removeAttribute('aria-modal');
      this.removeAttribute('aria-label');
    }
    this.inert = this.isDrawer() && !this.drawerOpen;
    this.fbtns.forEach((btn) => btn.setAttribute('aria-expanded', isDialog ? 'true' : 'false'));
  }
  drawerKeys(e){
    if(!this.drawerOpen || !this.isDrawer()) return;
    if(e.key === 'Escape'){
      this.closeMobileFilters();
    } else if(e.key === 'Tab' && e.shiftKey && document.activeElement === this.closeBtn){
      const items = Array.from(this.querySelectorAll('a[href], button, input, select, textarea, summary, tc-range-slider'))
        .filter((el) => !el.disabled && el.getClientRects().length);
      let last = items[items.length - 1];
      if(last && last.tagName === 'TC-RANGE-SLIDER' && last.shadowRoot){
        const pointers = last.shadowRoot.querySelectorAll('.pointer');
        last = pointers[pointers.length - 1];
      }
      if(last && last !== this.closeBtn){
        e.preventDefault();
        last.focus();
      }
    }
  }
  blockToggle(){
      const body = document.body,
        filters = document.querySelectorAll(".filter-horizontal .filters-title"),
        blocks = this.querySelectorAll('.filters-item');
      filters.forEach((blk) => {
        const act = blk.closest('.filters-item[open]');
        blocks.forEach((other) => {
           if(other !== act){
             other.removeAttribute('open');
           }
        });
      });
      body.addEventListener('click', function(e){
          blocks.forEach((blk) => {
            if(e.target.closest('.filters-item[open]')) return;
             blk.removeAttribute('open');
        });
      });
  }
}
customElements.define("filters-form", FiltersForm);

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});